import { render, staticRenderFns } from "./HamperData.vue?vue&type=template&id=4f08b4d7&scoped=true"
import script from "./HamperData.vue?vue&type=script&lang=js"
export * from "./HamperData.vue?vue&type=script&lang=js"
import style0 from "./HamperData.vue?vue&type=style&index=0&id=4f08b4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08b4d7",
  null
  
)

export default component.exports